import React from "react";
import { Flex, Text, Popup, Provider } from "@fluentui/react-northstar";
import PropTypes from "prop-types";

const PopupWithHeader = (props) => {
    const { headerText, trigger } = props;

    const popupContent = {
        className: "popup-with-header-content",
        content: (
            <Provider.Consumer
                render={(theme) => (
                    <Flex className={theme.siteVariables.themeString === "default"
                        ? "popup-with-header-content-container default" : "popup-with-header-content-container"}
                        column
                        fill
                        data-testid="popupWithHeaderContents">
                        <Text
                            data-testid="popupWithHeaderContentsHeader"
                            className="header-text"
                            weight="bold"
                            size="medium"
                        >
                            {headerText}
                        </Text>
                        <Text data-testid="popupWithHeaderContentsBody"
                            className="body-text">
                            {props.children}
                        </Text>
                    </Flex>)
                }
            ></Provider.Consumer >
        )
    }

    return (
        <Popup
            content={popupContent}
            pointing
            trigger={trigger}
            tabbableTrigger={false}
        />
    );
}

PopupWithHeader.propTypes = {
    headerText: PropTypes.string,
    trigger: PropTypes.node,
};

PopupWithHeader.defaultProps = {
    headerText: "",
};

export default PopupWithHeader;